// ./ui/LiveFeed.js
import React from "react";

export default function LiveFeed({ spins }) {
  const shortenAddress = (addr) => {
    if (!addr) return "0x0000...0000";
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <div className="w-full sm:w-64 mt-6 sm:mt-0 sm:ml-6 bg-gray-800 border-2 border-cyan-600 rounded-xl shadow-md p-4 text-white">
      <h3 className="text-lg font-bold text-cyan-400 mb-2">🎯 Last Spins</h3>
      <ul className="space-y-2 text-sm">
        {spins.slice(0, 10).map((spin, index) => (
          <li key={index} className="border-b border-gray-600 pb-1">
            <span className="font-mono text-cyan-300">{shortenAddress(spin.wallet)}</span> –{" "}
            <span className="font-semibold">{spin.result}</span>
          </li>
        ))}
        {spins.length === 0 && (
          <li className="text-gray-400 italic">No spins yet...</li>
        )}
      </ul>
    </div>
  );
}
